import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsActivitiesDocsComponent } from './settings-activities-docs.component';
import { MaterialModule } from 'src/app/material.module';
import { DocumentStatusesModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-statuses/document-statuses.module';
import { DocumentPrioritiesModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-priorities/document-priorities.module';
import { DocumentCategoriesModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-categories/document-categories.module';
import { DocumentTagsModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-tags/document-tags.module';
import { DocumentTypeModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-type/document-type.module';
import { EvenimentGenealogicModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/eveniment-genealogic/eveniment-genealogic.module';
import { ConditieMedicalaModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/conditie-medicala/conditie-medicala.module';
import { DocumentSectionsModule } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-sections/document-sections.module';


@NgModule({
    declarations: [
        SettingsActivitiesDocsComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        DocumentStatusesModule,
        DocumentPrioritiesModule,
        DocumentCategoriesModule,
        DocumentTagsModule,
        DocumentTypeModule,
        DocumentSectionsModule,
        EvenimentGenealogicModule,
        ConditieMedicalaModule,
    ],
    exports: [SettingsActivitiesDocsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsActivitiesDocsModule { }
